import { atom } from "jotai";

export const elementAtomData = atom<any>({ id: "" });
